import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import MemberGroupListListing from '@/modules/manage-member/components/MemberGroupList/components/MemberGroupListListing'
import useQueryGetMemberGroup from '@/modules/manage-member/api/hooks/useQueryGetMemberGroup'
import { useTablePagination } from '@/common/hooks/useTablePaginate'

function MemberGroupListPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		name: searchQuery,
	}

	const { data, isLoading } = useQueryGetMemberGroup(payload)

	return (
		<PageContainer>
			<MemberGroupListListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedMemberGroupListPage = withUserPermission(MemberGroupListPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_OPERATOR],
})

export default GuardedMemberGroupListPage
